import { components, GroupBase, OptionProps } from 'react-select';

import Checkbox from '@ui/checkbox/checkbox';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import { TReactSelectOption } from '../../custom-react-select.types';

type TOptionProps = OptionProps<unknown, boolean, GroupBase<unknown>> & {
  data: TReactSelectOption;
};

const Option = ({ children, data, ...rest }: TOptionProps) => {
  return (
    <components.Option data={data} {...rest}>
      <Container
        height="100%"
        width="100%"
        className="flex jc-space-between ai-center position-relative cursor-pointer"
      >
        {/* make inert so we don't so it doesn't steal focus when tabbing */}
        <Checkbox inert value={data.value} checked={rest.isSelected} className="pointer-events-none" />
        <Text color="var(--gray-300)" className="S3 flex-1 margin-l-8" width="100%" wordBreak="break-all" clamp={1}>
          {children}
        </Text>
      </Container>
    </components.Option>
  );
};

export default Option;
